import Model from './Model'
export default class Vehicle extends Model {

    resource()
    {
        return 'vehicles'
    }
}
